<script setup lang="ts">
import { useApp } from "@/vf"
import { computed, ref } from "vue"
import VuePdfEmbed from "vue-pdf-embed"

const props = defineProps<{
    file: string
    paginated?: boolean
}>()

const { apiLink } = useApp()

const pagesTotal = ref(0)
const page = ref(1)
const loading = computed(() => {
    return pagesTotal.value === 0
})

function pdfLoaded({ numPages }: { numPages: number }) {
    pagesTotal.value = numPages
}
</script>

<template>
    <div class="d-flex justify-content-center align-items-center" style="min-height: 200px" v-if="loading">
        <div class="spinner-border text-primary" role="status">
            <span class="sr-only">Loading...</span>
        </div>
    </div>
    <div class="pdf" :class="{ iso216: !loading && !props.paginated }">
        <div class="pdf__content">
            <VuePdfEmbed :source="apiLink(props.file)" :page="props.paginated ? page : undefined" @loaded="pdfLoaded" />
        </div>
        <div class="pdf__footer mt-4" v-if="props.paginated && pagesTotal > 1">
            <ul class="pagination justify-content-center">
                <li class="page-item" :class="{ disabled: page === 1 }">
                    <a class="page-link" :title="$t('crud:list.first_page')" @click.prevent="page = 1">
                        <i class="fa fa-fw fa-fast-backward"></i>
                    </a>
                </li>
                <li class="page-item" :class="{ disabled: page <= 1 }">
                    <a class="page-link" :title="$t('crud:list.prev_page')" @click.prevent="page--">
                        <i class="fa fa-fw fa-backward"></i>
                    </a>
                </li>
                <template v-for="index in pagesTotal" :key="index">
                    <li class="page-item disabled" v-if="index == page - 3">
                        <span class="page-link">...</span>
                    </li>
                    <li
                        class="page-item"
                        :class="{ active: index == page }"
                        v-if="index > page - 3 && index < page + 3"
                    >
                        <a class="page-link" @click.prevent="page = index">{{ index }}</a>
                    </li>
                    <li class="page-item disabled" v-if="index == page + 3">
                        <span class="page-link">...</span>
                    </li>
                </template>
                <li class="page-item" :class="{ disabled: page >= pagesTotal }">
                    <a class="page-link" :title="$t('crud:list.next_page')" @click.prevent="page++">
                        <i class="fa fa-fw fa-forward"></i>
                    </a>
                </li>
                <li class="page-item" :class="{ disabled: page === pagesTotal }">
                    <a class="page-link" :title="$t('crud:list.last_page')" @click.prevent="page = pagesTotal">
                        <i class="fa fa-fw fa-fast-forward"></i>
                    </a>
                </li>
            </ul>
        </div>
    </div>
</template>
<style>
.pdf.iso216 {
    overflow: auto;
    width: 100%;
    aspect-ratio: 1/1.414;
}
</style>
